// extracted by mini-css-extract-plugin
export default {"wrapper":"MediaGallery_wrapper__jUvRG"};